export default {
  small: 0,
  medium: 640,
  large: 1024,
};
